export const MenuIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className='close-svg-icon' {...props}>
        <path d='M2 5H22' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
        <path d='M2 12H22' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
        <path d='M2 19H22' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
);